import React, { useEffect, useRef, useState } from "react";
import "swiper/css";
import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/autoplay";
import DefaulteImage from "../../Utilisateure/visiteur/DefaulteImage.jpeg";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import "./Home.css";
import "swiper/swiper-bundle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import AfficheMagasinsService from "../../../Services/Magasin/AfficheMagasinsService";
import { MagasinInfo } from "../../../Modeles/MagasinModel";
import AfficheArticleInMagasin from "../../../Services/Magasin/AfficheArticleInMagasin";
import axios from "axios";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";

export interface ProductType       { product: ArticleInfo[]; messageErros: string; }
export interface ProductTypeMagasins { magasins: MagasinInfo[]; messageErrosMagasin: string; }

export default function Home() {
  const [states, setStates] = useState<ProductTypeMagasins>({ magasins: [] as MagasinInfo[], messageErrosMagasin: "Il n'y a pas de magasin" });
  const categories  = ["CATERPILLAR","JCB","VOLVO","PERKINS","LEBRERO","DOOSAN","LIEBHERR"];
  const [showAll, setShowAll]                   = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>("Tous");

  /* ── search: two states ── */
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch]           = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage                = 20;
  const [products, setProducts]       = useState<ArticleInfo[]>([]);
  const [totalPages, setTotalPages]   = useState(1);
  const [Refs, setRef]                = useState<any[]>([]);
  const [loading, setLoading]         = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [showPopup, setShowPopup]     = useState(false);
  const [waiting, setWaiting]         = useState(false);
  const [countdown, setCountdown]     = useState(180);
  const [Message, setMessage]         = useState("");
  const [securityCount, setSecurityCount] = useState(0);

  useEffect(() => {
    const fetchSecurityCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/securities/pending-count`);
        if (response.data && response.data.count !== undefined) {
          setSecurityCount(response.data.count);
        }
      } catch (error) {
        console.error("Error fetching security count", error);
      }
    };
    fetchSecurityCount();
  }, []);

  const UpdateArticles = async () => {
    setShowPopup(false); 
    setWaiting(true); 
    setCountdown(180);

    let remaining = 180;
    const interval = setInterval(() => {
      remaining -= 1; 
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    try {
      await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/articles`, { timeout: 300000 }); // Wait up to 5 minutes
    } catch (error) {
      console.error(error);
    } finally {
      clearInterval(interval);
      setWaiting(false);
      setMessage("Vos produits ont été mis à jour avec succès");
      setTimeout(() => setMessage(""), 3500);
      resetToDefault();
    }
  };

  const initialProductsRef = useRef<ArticleInfo[]>([]);
  const initialTotalPagesRef = useRef<number>(1);

  /* ── fetch products (append = load-more mode) ── */
  const fetchProducts = async (page = 1, append = false) => {
    try {
      append ? setLoadingMore(true) : setLoading(true);
      const res = await AfficheArticleInMagasin().getAnly20Article(page);
      const fetched = res.data.data ?? [];
      setProducts(prev => append ? [...prev, ...fetched] : fetched);
      setCurrentPage(res.data.current_page);
      setTotalPages(res.data.total_pages);
      if (!append && page === 1 && initialProductsRef.current.length === 0 && fetched.length > 0) {
        initialProductsRef.current = fetched;
        initialTotalPagesRef.current = res.data.total_pages;
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); setLoadingMore(false); }
  };

  /* ── fetch search results (append = load-more mode) ── */
  const getRef = async (searchTerm: string, page: number = 1, append = false, catParam: string | null = selectedCategory) => {
    try {
      const activeCat = (catParam && catParam !== "Tous") ? catParam : '';
      const queryToUse = searchTerm.trim();
      if (queryToUse === "" && !activeCat) { setRef([]); setTotalPages(1); setCurrentPage(1); return; }
      append ? setLoadingMore(true) : setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/search-articles`, {
        params: { q: queryToUse || undefined, categorie: activeCat || undefined, page, perPage: recordsPerPage }
      });
      setRef(prev => append ? [...prev, ...response.data.data] : response.data.data);
      setCurrentPage(response.data.current_page);
      setTotalPages(response.data.total_pages);
    } catch (error) { console.error("Error:", error); }
    finally { setLoading(false); setLoadingMore(false); }
  };

  /* ── reset everything to default product list ── */
  const resetToDefault = () => {
    setSearch(""); setSearchInput(""); setSelectedCategory("Tous");
    setRef([]); setCurrentPage(1);
    localStorage.removeItem("SaveTape");
    if (initialProductsRef.current.length > 0) {
      setProducts(initialProductsRef.current);
      setTotalPages(initialTotalPagesRef.current);
      setLoading(false);
    } else {
      fetchProducts(1, false);
    }
  };

  const handleClearCategory = () => {
    setSelectedCategory("Tous");
    const activeSearch = searchInput.trim() || search.trim();
    if (activeSearch !== "") {
      getRef(activeSearch, 1, false, "Tous");
    } else {
      resetToDefault();
    }
  };

  /* ── input change: if cleared → reset immediately or fallback to active category ── */
  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchInput(val);
    if (val.trim() === "") {
      if (selectedCategory && selectedCategory !== "Tous") {
        setSearch("");
        getRef("", 1, false, selectedCategory);
      } else {
        resetToDefault();
      }
    }
  };

  /* ── commit search on icon click or Enter ── */
  const triggerSearch = () => {
    const val = searchInput.trim();
    setSearch(val); setRef([]); setCurrentPage(1);
    getRef(val, 1, false, selectedCategory);
  };
  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => { if (e.key === "Enter") triggerSearch(); };

  /* ── Suivant: append next page ── */
  const handleSuivant = () => {
    if (currentPage >= totalPages) return;
    const next = currentPage + 1;
    const activeSearch = searchInput.trim() || search.trim();
    const activeCat = (selectedCategory && selectedCategory !== "Tous") ? selectedCategory : '';
    if (activeSearch !== "" || activeCat !== "") getRef(activeSearch, next, true, selectedCategory);
    else fetchProducts(next, true);
  };
  const hasMore = currentPage < totalPages;

  const filteByCategory = async (categoryName: any, page = 1) => {
    try {
      let newCat: string | null = categoryName;
      if (selectedCategory === categoryName || categoryName === "Tous") {
        handleClearCategory();
        return;
      }
      setSelectedCategory(newCat);
      const currentQuery = searchInput.trim();
      setSearch(currentQuery);
      getRef(currentQuery, page, false, newCat);
    } catch (error) { console.error(error); }
  };

  useEffect(() => {
    AfficheMagasinsService().getMagasin()
      .then(res => setStates({ ...states, magasins: res.data }))
      .catch(msg => setStates({ ...states, messageErrosMagasin: msg.messageErrosMagasin }));
  }, []);
  useEffect(() => {
    const saved = localStorage.getItem("SaveTape");
    if (!saved || saved.trim() === "") return;
    setSearch(saved); setSearchInput(saved);
    getRef(saved, 1, false);
  }, []);
  useEffect(() => { fetchProducts(1, false); }, []);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const displayData = Refs.length > 0 ? Refs : products;
  const { magasins, messageErrosMagasin } = states;

  const Loader = ({ compact = false }: { compact?: boolean }) => (
    <div className={`h-ad-up-loader ${compact ? "h-ad-up-loader-sm" : ""}`}>
      <div className="h-ad-up-spinner" /><span className="h-ad-up-loader-text">Chargement…</span>
    </div>
  );
  const EmptyState = () => (
    <div className="h-ad-up-empty">
      <div className="h-ad-up-empty-icon"><i className="bi bi-search" /></div>
      <h6 className="h-ad-up-empty-title">Aucun résultat trouvé</h6>
      <p className="h-ad-up-empty-hint">Essayez un mot similaire ou quelque chose de plus général.</p>
    </div>
  );
  const SuivantBtn = () => (
    <div style={{ display:"flex", justifyContent:"center", margin:"28px 0 10px" }}>
      <button onClick={handleSuivant} disabled={loadingMore}
        style={{ padding:"12px 44px", background: loadingMore ? "#e5e7eb" : "#ffc400", border:"none", borderRadius:"10px", fontWeight:700, fontSize:"1rem", color:"#1a1a1a", cursor: loadingMore ? "not-allowed" : "pointer", display:"flex", alignItems:"center", gap:"10px", transition:"all 0.2s", boxShadow:"0 3px 8px rgba(255,196,0,0.3)" }}>
        {loadingMore
          ? <><span style={{ width:16, height:16, border:"3px solid #999", borderTop:"3px solid #333", borderRadius:"50%", display:"inline-block", animation:"spin 0.8s linear infinite" }} /> Chargement…</>
          : <><i className="bi bi-arrow-down-circle" /> Suivant</>}
      </button>
    </div>
  );

  const renderCard = (pro: any, linkTo: string) => {
    const imgSrc    = pro.urlImage ? pro.urlImage : DefaulteImage;
    const outOfStock = (pro.Quantité ?? pro.Qte ?? 0) <= 0;
    return (
      <div className={`uc2-card-hvu ${outOfStock ? "uc2-card-nostock-hvu" : ""}`}>
        <div className="uc2-img-zone-hvu">
          <img src={imgSrc} alt={pro.Designation} className={`uc2-img-hvu ${outOfStock ? "uc2-img-grey-hvu" : ""}`} />
          <span className="uc2-brand-chip-hvu">{pro.NomMarque ? pro.NomMarque : "Pièce"}</span>
          {outOfStock
            ? <div className="uc2-stock-badge-hvu uc2-stock-out-hvu"><i className="bi bi-x-circle-fill" /> Stock épuisé</div>
            : <div className="uc2-stock-badge-hvu uc2-stock-in-hvu"><i className="bi bi-check-circle-fill" /> En stock</div>}
          {!outOfStock && (
            <div className="uc2-card-hover-actions-hvu">
              <button className="uc2-card-action-btn-hvu" aria-label="Favoris"><i className="bi bi-suit-heart" /></button>
              <button className="uc2-card-action-btn-hvu uc2-card-action-gold-hvu" aria-label="Voir"><i className="bi bi-eye" /></button>
            </div>
          )}
        </div>
        <div className="uc2-body-hvu">
          <div className="uc2-stars-hvu">{[...Array(5)].map((_, i) => <i key={i} className="bi bi-star-fill uc2-star-i-hvu" />)}</div>
          <div className="uc2-title-hvu">{pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}</div>
          <p className="uc2-ref-hvu">Réf : {pro.RefArticle}</p>
          <div className="uc2-footer-row-hvu">
            <div className="uc2-price-hvu">{parseFloat(String(pro?.PrixNetHT ?? 0).replace(",", ".")).toFixed(2)}<span className="uc2-currency-hvu"> MAD</span></div>
            <span className="uc2-store-tag-hvu"><i className="bi bi-shop" /> {pro.NomMagasin ?? "—"}</span>
          </div>
        </div>
      </div>
    );
  };

  const WaitingOverlay = () => (
    <div className="upd-overlay"><div className="upd-box">
      <div className="upd-ring">
        <svg viewBox="0 0 120 120" className="upd-ring-svg">
          <circle cx="60" cy="60" r="52" className="upd-ring-track" />
          <circle cx="60" cy="60" r="52" className="upd-ring-progress"
            style={{ strokeDasharray:`${2*Math.PI*52}`, strokeDashoffset:`${2*Math.PI*52*(countdown/180)}` }} />
        </svg>
        <span className="upd-ring-time">{Math.floor(countdown/60)}:{String(countdown%60).padStart(2,"0")}</span>
      </div>
      <h2 className="upd-title">Mise à jour en cours…</h2>
      <p className="upd-subtitle">Vos produits sont en cours de mise à jour.<br/>Veuillez patienter quelques minutes.</p>
      <div className="upd-steps">
        <div className={`upd-step ${countdown<=180?"upd-step-done":""}`}><i className="bi bi-cloud-download"/> Récupération des données</div>
        <div className={`upd-step ${countdown<=120?"upd-step-done":"upd-step-wait"}`}><i className="bi bi-arrow-repeat"/> Synchronisation des articles</div>
        <div className={`upd-step ${countdown<=30 ?"upd-step-done":"upd-step-wait"}`}><i className="bi bi-check2-circle"/> Finalisation</div>
      </div>
      <div className="upd-bar-wrap"><div className="upd-bar-fill" style={{width:`${((180-countdown)/180)*100}%`}}/></div>
      <p className="upd-bar-label">{Math.round(((180-countdown)/180)*100)}% complété</p>
    </div></div>
  );

  const PopupOverlay = () => (
    <div className="a-ad-up-overlay"><div className="a-ad-up-popup">
      <div className="a-ad-up-popup-icon"><i className="bi bi-arrow-repeat"/></div>
      <h5 className="a-ad-up-popup-title">Mettre à jour les articles ?</h5>
      <p className="a-ad-up-popup-text">Cette action synchronise tous vos produits depuis la source.</p>
      <div className="a-ad-up-popup-actions">
        <button className="a-ad-up-popup-btn-cancel" onClick={()=>setShowPopup(false)}>Annuler</button>
        <button className="a-ad-up-popup-btn-confirm" onClick={UpdateArticles} disabled={loading}><i className="bi bi-check-lg"/>{loading?"En cours…":"Confirmer"}</button>
      </div>
    </div></div>
  );

  /* ══════ MOBILE ══════ */
  if (screenWidth <= 768) {
    return (
      <>
        <NewSideBarAdmin />
        {showPopup && <PopupOverlay />}
        {waiting   && <WaitingOverlay />}
        <div className="h-ad-up-mobile-hero">
          <div className="a-ad-up-topbar">
            <div className="a-ad-up-topbar-actions">
              <Link to="/articles/categories/add" className="a-ad-up-btn-add"><i className="bi bi-plus-lg"/> Ajouter un produit</Link>
              <Link to="/demandes/modifications" className="a-ad-up-btn-refresh" title="Demandes de modification" style={{ position: "relative" }}>
                <i className="bi bi-shield-lock"/>
                {securityCount > 0 && (
                  <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "#ef4444", color: "white", fontSize: "0.65rem", fontWeight: "bold", padding: "2px 5px", borderRadius: "10px", lineHeight: "1" }}>
                    {securityCount}
                  </span>
                )}
              </Link>
              <button className="a-ad-up-btn-refresh" onClick={()=>setShowPopup(true)} title="Actualiser les produits"><i className="bi bi-arrow-repeat"/></button>
            </div>
          </div>
          <div className="h-ad-up-mobile-search-row">
            <div className="h-ad-up-mobile-search-wrap">
              <i className="bi bi-search h-ad-up-mobile-search-icon" style={{cursor:"pointer"}} onClick={triggerSearch}/>
              <input type="text" className="h-ad-up-mobile-search-input"
                onChange={handleSearchInputChange} onKeyDown={handleSearchKeyDown} value={searchInput} placeholder="Chercher un produit…"/>
              {searchInput && <button className="h-ad-up-mobile-search-clear" onClick={resetToDefault}><i className="bi bi-x"/></button>}
            </div>
          </div>
        </div>
        <div className="h-ad-up-mobile-body">
          {loading ? <Loader compact/> : (
            <>
              <div className="h-ad-up-section">
                <div className="h-ad-up-section-header">
                  <span className="h-ad-up-section-title">Meilleures ventes{selectedCategory&&selectedCategory!=="Tous"&&<span className="h-ad-up-section-filter-tag"> · {selectedCategory}</span>}</span>
                </div>
                {displayData&&displayData.length>0 ? (
                  <><div className="h-ad-up-product-grid">
                    {displayData.map(pro=>{
                      const encodedRef=btoa(encodeURIComponent(pro?.RefArticle??""));
                      const linkTo=`/home/${encodeURIComponent(pro?.NomMagasin??"")}/articles/${encodedRef}`;
                      return <Link key={pro?.IdArticle} className="h-ad-up-product-link" to={linkTo}>{renderCard(pro,linkTo)}</Link>;
                    })}
                  </div>{hasMore&&<SuivantBtn/>}</>) : <EmptyState/>}
              </div>
              <div className="h-ad-up-section h-ad-up-section-mag">
                <div className="h-ad-up-section-header">
                  <span className="h-ad-up-section-title"><i className="bi bi-shop h-ad-up-section-icon"/> Magasins</span>
                  <Link to="/magasin" className="h-ad-up-see-all">Voir tout <i className="bi bi-arrow-right-short"/></Link>
                </div>
                <div className="h-ad-up-mag-scroll">
                  {magasins&&magasins.length>0 ? magasins.map(mag=>(
                    <Link key={mag.IdMagasin} to={`/magasin/${mag.IdMagasin}/edit`} className="h-ad-up-mag-chip-link">
                      <div className="h-ad-up-mag-chip">
                        <div className="h-ad-up-mag-chip-icon"><i className="bi bi-shop-window"/></div>
                        <div className="h-ad-up-mag-chip-info">
                          <span className="h-ad-up-mag-chip-name">{mag.NomMagasin}</span>
                          <span className="h-ad-up-mag-chip-city"><i className="bi bi-geo-alt-fill"/>{(mag.adresse_de_siege&&mag.adresse_de_siege.split(",")[0]?.trim())||"Casablanca"}</span>
                        </div>
                        <i className="bi bi-chevron-right h-ad-up-mag-chip-arrow"/>
                      </div>
                    </Link>
                  )) : <p className="h-ad-up-mag-empty">{messageErrosMagasin}</p>}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }

  /* ══════ DESKTOP ══════ */
  return (
    <>
      {waiting&&<WaitingOverlay/>}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"/>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <NewSideBarAdmin/>
      <div className="h-ad-up-desktop">
        <div className="a-ad-up-topbar">
          <div className="a-ad-up-topbar-left"><h3 className="a-ad-up-page-title">Tous les produits</h3></div>
          <div className="a-ad-up-topbar-actions">
            <Link to="/demandes/modifications" className="a-ad-up-btn-refresh" title="Demandes de modification" style={{ position: "relative" }}>
              <i className="bi bi-shield-lock"/>
              {securityCount > 0 && (
                <span style={{ position: "absolute", top: "-5px", right: "-5px", background: "#ef4444", color: "white", fontSize: "0.65rem", fontWeight: "bold", padding: "2px 5px", borderRadius: "10px", lineHeight: "1" }}>
                  {securityCount}
                </span>
              )}
            </Link>
            <Link to="/articles/categories/add" className="a-ad-up-btn-add"><i className="bi bi-plus-lg"/> Ajouter un produit</Link>
            <button className="a-ad-up-btn-refresh" onClick={()=>setShowPopup(true)} title="Actualiser les produits"><i className="bi bi-arrow-repeat"/></button>
          </div>
        </div>
        <div className="h-ad-up-search-bar">
          <div className="h-ad-up-search-wrap">
            <i className="bi bi-search h-ad-up-search-icon" style={{cursor:"pointer"}} onClick={triggerSearch}/>
            <input type="text" className="h-ad-up-search-input"
              onChange={handleSearchInputChange} onKeyDown={handleSearchKeyDown} value={searchInput}
              placeholder="Rechercher un produit, référence, catégorie…"/>
            {searchInput&&<button className="h-ad-up-search-clear" onClick={resetToDefault}><i className="bi bi-x"/></button>}
          </div>
        </div>
        <div className="h-ad-up-result-bar">
          <span className="h-ad-up-result-count"><b>+57 900</b> résultats trouvés</span>
          {selectedCategory&&selectedCategory!=="Tous"&&(
            <span className="h-ad-up-active-filter"><i className="bi bi-funnel-fill"/> {selectedCategory}
              <button className="h-ad-up-clear-filter" onClick={handleClearCategory}>×</button>
            </span>
          )}
        </div>
        {loading ? <Loader/> : (
          <>
            <div className="h-ad-up-desktop-grid">
              {displayData&&displayData.length>0
                ? displayData.map(pro=>{
                    const encodedRef=btoa(encodeURIComponent(pro?.RefArticle??""));
                    const linkTo=`/home/${encodeURIComponent(pro?.NomMagasin??"")}/articles/${encodedRef}`;
                    return <Link key={pro.id??pro.IdArticle} className="h-ad-up-product-link" to={linkTo}>{renderCard(pro,linkTo)}</Link>;
                  })
                : <div className="h-ad-up-empty-desktop"><EmptyState/></div>}
            </div>
            {hasMore&&displayData.length>0&&<SuivantBtn/>}
            <div className="h-ad-up-mag-section">
              <div className="h-ad-up-mag-header"><h5 className="h-ad-up-mag-title"><i className="bi bi-shop"/> Voir vous magasins</h5></div>
              <div className="h-ad-up-mag-swiper-wrap">
                <Swiper freeMode grabCursor className="h-ad-up-mag-swiper"
                  breakpoints={{0:{slidesPerView:1,spaceBetween:12},480:{slidesPerView:2,spaceBetween:14},700:{slidesPerView:3.5,spaceBetween:16},1100:{slidesPerView:4.5,spaceBetween:16}}}
                  autoplay={{delay:2300,disableOnInteraction:false}}
                  navigation={{prevEl:".h-ad-up-prev",nextEl:".h-ad-up-next"}}
                  modules={[Autoplay,FreeMode,Navigation]}>
                  {magasins&&magasins.length>0 ? magasins.map(mag=>(
                    <SwiperSlide key={mag.IdMagasin}>
                      <Link to={`/magasin/${mag.IdMagasin}/edit`} className="h-ad-up-mag-link">
                        <div className="h-ad-up-mag-card">
                          <div className="h-ad-up-mag-icon"><i className="bi bi-shop-window"/></div>
                          <h6 className="h-ad-up-mag-name">{mag.NomMagasin}</h6>
                          <p className="h-ad-up-mag-address"><i className="bi bi-geo-alt-fill h-ad-up-mag-loc"/>{(mag.adresse_de_siege&&mag.adresse_de_siege.split(",")[0]?.trim())||"Casablanca"}</p>
                          <p className="h-ad-up-mag-city">{(mag.adresse_de_siege&&mag.adresse_de_siege.split(",")[1]?.trim())||"Casablanca"}</p>
                        </div>
                      </Link>
                    </SwiperSlide>
                  )) : <p className="h-ad-up-mag-empty">{messageErrosMagasin}</p>}
                </Swiper>
                <button className="h-ad-up-swiper-nav h-ad-up-prev"><i className="bi bi-chevron-left"/></button>
                <button className="h-ad-up-swiper-nav h-ad-up-next"><i className="bi bi-chevron-right"/></button>
              </div>
            </div>
          </>
        )}
      </div>
      {showPopup&&<PopupOverlay/>}
    </>
  );
}